import { action, observable, makeObservable } from 'mobx';
import workflowApi from '../api';

export default class EntityTaskStore {
  loading = true;
  tasks = [];

  constructor() {
    makeObservable(this, {
      loading: observable,
      tasks: observable,
      loadTasksByEntityId: action.bound,
      onTasksLoadedByEntityId: action.bound,
      updateTask: action.bound,
      addComment: action.bound
    });
  }

  loadTasksByEntityId(entityId) {
    this.loading = true;
    workflowApi.loadTasksByEntityIds([entityId])
      .then(this.onTasksLoadedByEntityId);
  }

  onTasksLoadedByEntityId(resp) {
    this.loading = false;
    this.tasks = resp.tasks ||  [];
  }

  updateTask(task) {
    workflowApi.saveTask(task).then(action("storeUpdatedTask", updated => {
      this.tasks = this.tasks.map(t => t._id === updated.task._id ? updated.task : t)
    }))
  }

  addComment(task, comment) {
    workflowApi.addComment(task._id, comment).then(action("storeTaskComment", updated => {
      this.tasks = this.tasks.map(t => t._id === updated.task._id ? updated.task : t)
    }))
  }
}
